import { render, staticRenderFns } from "./kraken.vue?vue&type=template&id=69aeb4a5"
import script from "./kraken.vue?vue&type=script&lang=js"
export * from "./kraken.vue?vue&type=script&lang=js"
import style0 from "./kraken.vue?vue&type=style&index=0&id=69aeb4a5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports